/**
 * SPA entry · P1.8 skeleton
 *
 * - QueryClient (TanStack Query · empty cache for now)
 * - Router (TanStack Router · file-based routes in src/routes/)
 * - Theme: data-theme="sketch" default · matches design/canvas-first-v5.html
 *   v0.1 · v0.2 may add toggle to clean / dark via header menu
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Reasonable defaults · cache 30s · refetch on focus
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Set default theme on <html> · sketch matches design/canvas-first-v5.html
document.documentElement.setAttribute('data-theme', 'sketch');

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No #root element in index.html');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
